import { useContext } from 'react';

import { DrawerContext } from './index';

export function useDrawer() {
  return useContext(DrawerContext);
}
